import { observer } from 'mobx-react-lite'
import { DeleteBusinessProfileDialog } from '@/features/tax-profile/business-profiles/components/DeleteBusinessProfileDialog'
import { type DeleteBusinessProfileDialogViewModel } from '@/features/tax-profile/business-profiles/DeleteBusinessProfileDialogViewModel'

export interface DeleteBusinessProfileDialogContainerProps {
  vm: DeleteBusinessProfileDialogViewModel
}

/**
 * Container component for the delete business profile dialog.
 */
export const DeleteBusinessProfileDialogContainer = observer(
  ({ vm }: DeleteBusinessProfileDialogContainerProps) => {
    const displayName = vm.businessProfile?.businessInfo.businessName ?? ''

    return (
      <DeleteBusinessProfileDialog
        isOpen={vm.modal.showing}
        onClose={vm.cancel}
        displayName={displayName}
        isDeletePending={vm.delete.pending}
        onConfirmDeletePress={vm.delete}
      />
    )
  },
)
